"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Behance;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Behance(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Behance"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "behance",
    d: "M42.222,47.4c4.417-2.111,6.722-5.306,6.722-10.278,0-9.805-7.3-12.194-15.736-12.194H10V74.146H33.861c8.945,0,17.347-4.292,17.347-14.292,0-6.18-2.93-10.75-8.986-12.458Zm-21.4-14.07H30.972c3.9,0,7.417,1.1,7.417,5.625,0,4.181-2.736,5.861-6.6,5.861H20.819Zm11.57,32.459H20.819V52.229H32.611c4.764,0,7.778,1.986,7.778,7.028,0,4.972-3.6,6.528-8,6.528ZM82.181,32.354H62.222V27.507H82.181v4.847ZM90,56.84C90,46.3,83.833,37.507,72.653,37.507c-10.861,0-18.236,8.167-18.236,18.861,0,11.1,6.986,18.708,18.236,18.708,8.514,0,14.028-3.833,16.68-11.986H80.694c-.93,3.042-4.763,4.653-7.736,4.653-5.736,0-8.75-3.361-8.75-9.069H89.917C89.958,58.09,90,57.465,90,56.84ZM64.222,52.507c.32-4.681,3.431-7.611,8.125-7.611,4.917,0,7.389,2.889,7.806,7.611Z"
  })));
}